import { Component } from '@angular/core';

@Component({
  selector: 'app-registry-description',
  templateUrl: './registry-description.component.html',
  styleUrls: ['./registry-description.component.scss']
})
export class RegistryDescriptionComponent {
}
